import { useMemo } from 'react';
import { getEspeciallyClassName } from '../../professional_unit';
import { useBoolState } from '../useHook';
/**
 * 経験テーマの表示制御を行うuse
 * @param unitThemes
 * @param allUnitThemes
 * @returns {{allList, hideModal: (function(): void), isShowModal: boolean, list, showModal: (function(): void)}}
 */
export const useProfessionalUnitExperiencedThemeItems = (unitThemes, allUnitThemes) => {
    const { boolState: isShowModal, changeFalse: hideModal, changeTrue: showModal, } = useBoolState(false);
    // モーダルで全表示用
    const list = useMemo(() => allUnitThemes.map((theme) => {
        const { especially } = unitThemes.find((v) => v.professionalOrganizationUnitThemeId === theme.id) || {};
        return Object.assign(Object.assign({}, theme), { className: getEspeciallyClassName(especially) });
    }), [allUnitThemes, unitThemes]);
    return {
        hideModal,
        isShowModal,
        list,
        showModal,
    };
};
export const useProfessionalUnitExperiencedThemes = {
    useProfessionalUnitExperiencedThemeItems,
};
